import ImageWithFallback from "../app/ImageWithFallback";

export default function RoomLogo({
  logoUrl,
  style,
}: {
  logoUrl?: string | null;
  style?: React.CSSProperties;
}) {
  return (
    <ImageWithFallback
      image={
        <img
          className="room-logo object-contain flex-shrink-0 w-[30px] h-[30px] min-w-[30px] min-h-[30px] border-[1px] border-solid border-secondary-bluegrey-3 rounded-[50%] bg-white"
          style={style}
          src={logoUrl ?? ""}
          alt="logo"
        />
      }
      fallback={
        <div
          className="room-logo-placeholder w-[30px] h-[30px] min-w-[30px] min-h-[30px] rounded-[50%] bg-[#e5e5e5]"
          style={style}
        />
      }
    />
  );
}
